export const horizontalSplitResize = (state) => ({
    type: "HORIZONTAL_SPLIT_RESIZE",
    payload: { state },
  });

  export const screenShareSplitResize = (state) => ({
    type: "SCREEN_SHARE_SPLIT_RESIZE",
    payload: { state },
  });